











import Vue, { VueConstructor } from 'vue'
import XTabs, { TabItem } from '@/components/atoms/Tab/XTabs.vue'
import TotalRetailAffiliate from '@/components/molecules/Affiliate/Retail/TotalRetailAffiliate.vue'
import TotalSetAffiliate from '@/components/molecules/Affiliate/Set/TotalSetAffiliate.vue'

type Data = {
  selectedTab?: string
}

type Computed = {
  tabs: TabItem[]
  currentComponent?: string
}

const components: {
  ['retail']: VueConstructor<Vue>
  ['set']: VueConstructor<Vue>
} = {
  retail: TotalRetailAffiliate,
  set: TotalSetAffiliate,
}

export default Vue.extend<Data, {}, {}, {}>({
  name: 'TotalAffiliate',
  components: {
    XTabs,
    ...components,
  },
  data() {
    return { selectedTab: undefined }
  },
  computed: {
    currentComponent() {
      return this.selectedTab
    },
    tabs() {
      return [
        {
          id: 'retail',
          label: this.$tc('affiliate.retail'),
        },
        {
          id: 'set',
          label: this.$tc('affiliate.set'),
        },
      ]
    },
  },
})
